import React, { useCallback, useContext } from 'react'
import { useSeasonalData } from './useSeasonals'
import { seasonalHelpers } from '../cnr/reducers/reducerHelpers/seasonalHelpers'
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { DatabaseContext } from 'global/cnr/contexts/DatabaseContext';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';

export const useSportsCollection = () => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states
  const { pathViews } = paps_state

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info } = sportsSeason_state ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  const seasonalDataHelpers = useSeasonalData()

  const getSportsCollectionItem = useCallback(async ({ collectionName, subCollectionName }) => {
    const _pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])
    const _sportsYearCollectionItem = await seasonalDataHelpers.getSports_collectionItem(_pks, collectionName, true)
    console.log('_sportsYearCollectionItem', _sportsYearCollectionItem)
    if (_sportsYearCollectionItem) {
      const refPath = createRefPath_event(pathViews, [collectionName, _sportsYearCollectionItem?._itemKey, subCollectionName])
      const data = await database_fns.get_data({ refPath })
      console.log('data', data)
    }
    return _sportsYearCollectionItem
  }, [])

  return { getSportsCollectionItem }

}
